import React, { useCallback, useRef, useState } from 'react';
import { useHistory } from "react-router-dom";
import Popup from 'popup/Popup';
import { customAxiosPostFunction } from 'utils/axiosFunction';

import { PasswordPopupContainer } from './DeleteEventLog.css';

const DeleteEventLog = ({ setData }) => {
  const history = useHistory();
  const [ popupOpen, setPopupOpen ] = useState(false);
  const inputEl = useRef(null);
  const deleteEventLogFunction = useCallback(async () => {
    const password = inputEl.current.value;

    if (password !== 'admin1020!@') {
      alert('올바른 비밀번호를 입력해주세요.');
      return false;
    }
    
    if (!window.confirm("모든 이벤트 이력이 삭제됩니다. 계속하시겠습니까?")) {
      return false;
    }

    customAxiosPostFunction(history, '/api/log/delete')
      .then(response => {
        if (response !== 0) {
          alert('삭제가 완료되었습니다.')
          setData([]);
          setPopupOpen(false);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }, [])

  return (
    <Popup
      trigger={
        <div className="search-condition col-xl-3 col-sm-6">
          <button className="table-search-submit btn btn-info">이벤트 초기화</button>
        </div>
      }
      modal
      closeOnDocumentClick
      open={popupOpen}
      onOpen={() => { setPopupOpen(true); }}
      >
        <PasswordPopupContainer>
          <div>
            비밀번호 : <input type="password" ref={inputEl} />
          </div>
          <div>
            <button className="btn btn-primary" onClick={() => { deleteEventLogFunction(); }}>초기화</button>
          </div>
        </PasswordPopupContainer>
      </Popup>
  )
}

export default React.memo(DeleteEventLog);